import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { AbstractControl, UntypedFormGroup, NgForm } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { FieldOption, IFieldConfig } from '../../../models';
import { FormsValidators } from '../validators';
import { FormatService } from '../../../services';

@Injectable()
export class FormsService {
  private readonly formatService = inject(FormatService);

  valid(form: UntypedFormGroup, fieldConfig: IFieldConfig, formRef: NgForm) {
    if (form.controls[fieldConfig.name]) {
      return form.controls[fieldConfig.name].valid && (form.controls[fieldConfig.name].touched || formRef.submitted);
    }
  }

  invalid(form: UntypedFormGroup, fieldConfig: IFieldConfig, formRef: NgForm) {
    return !form.controls[fieldConfig.name].valid && (form.controls[fieldConfig.name].touched || formRef.submitted);
  }

  stringToIsoUtcString(dateString: string): string {
    if (dateString) {
      return new Date(dateString).toISOString();
    }
    return '';
  }

  requiredFileType(type: string) {
    return function(control: AbstractControl) {
      const file = control.value;
      if (file) {
        const extension = file.name.split('.')[1].toLowerCase();
        if (type.toLowerCase() !== extension.toLowerCase()) {
          return {
            requiredFileType: true,
          };
        }
        return null;
      }
      return null;
    };
  }

  showIndicator(config: any) {
    return (
      config.validation &&
      config.validation.length > 0 &&
      config.validation.some((x: any) => {
        return FormsValidators.validationExist(x);
      })
    );
  }

  toFormData<T extends Record<string, any>>(formValue: T) {
    const formData = new FormData();

    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      formData.append(key, value);
    }
    return formData;
  }

  uploadProgress<T>(cb: (progress: number) => void) {
    return tap((event: HttpEvent<T>) => {
      if (event.type === HttpEventType.UploadProgress) {
        return cb(Math.round((100 * event.loaded) / (event.total || 1)));
      }
    });
  }

  buildOptionsFromEnum(enumeration: any, convertToLowerCase: boolean = true): FieldOption[] {
    const propertyNames = this.formatService.getEnumPropertyNames(enumeration);
    return propertyNames.map((prop) => {
      return {
        value: enumeration[prop],
        text: this.formatService.toSentenceCase(prop, convertToLowerCase),
      } as FieldOption;
    });
  }
}
